const en = {
  landing_proudly_serving: "Proudly serving Québec",
  landing_hero_title: "Your ride. Your city. Right on time.",
  landing_hero_subtitle: "Book a reliable taxi in seconds with professional local drivers across Québec.",
  landing_book_ride: "Book a ride",
  landing_discover: "Discover QC.Taxi",
  landing_fast_booking: "Fast booking",
  landing_local_drivers: "Local drivers",
  landing_secure_rides: "Secure rides",
  landing_simple_title: "Simple from start to finish",
  landing_simple_subtitle: "Three quick steps. No unnecessary detours.",
  landing_step_where_title: "Tell us where",
  landing_step_where_text: "Enter your pickup and destination.",
  landing_step_ride_title: "Choose your ride",
  landing_step_ride_text: "Pick the vehicle that fits your trip.",
  landing_step_go_title: "You're on your way",
  landing_step_go_text: "A local driver takes care of the rest.",
  landing_start_booking: "Start booking",
  landing_signin_booking: "Sign in to book",
  landing_ride_way: "Ride your way",
  landing_choose_trip: "Choose what fits your trip.",
  landing_clear_choices: "Clear choices. Upfront details. No guesswork.",
  landing_popular: "Popular",
  landing_built_day: "Built around your day",
  landing_everything_needed: "Everything you need. Nothing you don't.",
  landing_service_demand_title: "Ride on demand",
  landing_service_demand_text: "A nearby taxi when you need it.",
  landing_service_schedule_title: "Plan ahead",
  landing_service_schedule_text: "Schedule your pickup in advance.",
  landing_service_accessible_title: "Accessible rides",
  landing_service_accessible_text: "Comfortable options for every passenger.",
  landing_service_payments_title: "Easy payments",
  landing_service_payments_text: "Simple, secure payment choices.",
  landing_service_tracking_title: "Live tracking",
  landing_service_tracking_text: "Follow your driver in real time.",
  landing_service_local_title: "Local professionals",
  landing_service_local_text: "Trusted drivers who know Québec.",
  landing_app_eyebrow: "QC.Taxi in your pocket",
  landing_app_title: "Book. Track. Ride.",
  landing_app_text: "Your next ride is only a few taps away. Download the app and move around Québec with confidence.",
  landing_footer_tagline: "Local rides. Professional drivers. Québec.",
  landing_rights: "All rights reserved.",
};

const fr = {
  landing_proudly_serving: "Fièrement au service du Québec",
  landing_hero_title: "Votre trajet. Votre ville. Toujours à l'heure.",
  landing_hero_subtitle: "Réservez un taxi fiable en quelques secondes avec des chauffeurs professionnels d'ici.",
  landing_book_ride: "Réserver un trajet",
  landing_discover: "Découvrir QC.Taxi",
  landing_fast_booking: "Réservation rapide",
  landing_local_drivers: "Chauffeurs locaux",
  landing_secure_rides: "Trajets sécuritaires",
  landing_simple_title: "Simple du début à la fin",
  landing_simple_subtitle: "Trois étapes rapides. Aucun détour inutile.",
  landing_step_where_title: "Indiquez votre trajet",
  landing_step_where_text: "Entrez votre départ et votre destination.",
  landing_step_ride_title: "Choisissez votre véhicule",
  landing_step_ride_text: "Sélectionnez l'option adaptée à votre trajet.",
  landing_step_go_title: "Vous êtes prêt",
  landing_step_go_text: "Un chauffeur local s'occupe du reste.",
  landing_start_booking: "Commencer la réservation",
  landing_signin_booking: "Se connecter pour réserver",
  landing_ride_way: "Roulez à votre façon",
  landing_choose_trip: "Le bon véhicule pour chaque trajet.",
  landing_clear_choices: "Des choix clairs. Des détails précis. Sans surprise.",
  landing_popular: "Populaire",
  landing_built_day: "Pensé pour votre quotidien",
  landing_everything_needed: "Tout ce qu'il vous faut. Rien de superflu.",
  landing_service_demand_title: "Taxi sur demande",
  landing_service_demand_text: "Un taxi à proximité lorsque vous en avez besoin.",
  landing_service_schedule_title: "Planifiez à l'avance",
  landing_service_schedule_text: "Programmez votre prise en charge à l'avance.",
  landing_service_accessible_title: "Trajets accessibles",
  landing_service_accessible_text: "Des options confortables pour chaque passager.",
  landing_service_payments_title: "Paiements faciles",
  landing_service_payments_text: "Des modes de paiement simples et sécurisés.",
  landing_service_tracking_title: "Suivi en direct",
  landing_service_tracking_text: "Suivez votre chauffeur en temps réel.",
  landing_service_local_title: "Professionnels d'ici",
  landing_service_local_text: "Des chauffeurs fiables qui connaissent le Québec.",
  landing_app_eyebrow: "QC.Taxi dans votre poche",
  landing_app_title: "Réservez. Suivez. Roulez.",
  landing_app_text: "Votre prochain trajet est à quelques touchers. Téléchargez l'application et déplacez-vous au Québec en toute confiance.",
  landing_footer_tagline: "Trajets locaux. Chauffeurs professionnels. Québec.",
  landing_rights: "Tous droits réservés.",
};

export const landingResources = {
  en: { translations: en },
  fr: { translations: fr },
  "fr-CA": { translations: fr },
};
